import { useCredential, useCredentials } from '@commenda/api';
import { Alert, Icons } from '@commenda/kakashi';
import { IBusinessEntity } from '@commenda/types';
import {
  CredentialBlockType,
  CredentialsGetExtensibleFields,
} from '@commenda/types/src/credential/types';
import { RegistrationHelper } from '@commenda/utils';
import { DataPoint } from '../../common/DataPoint';
import { SummaryInfoWrapper } from './SummaryInfoWrapper';

export const CredentialCard = ({
  businessEntity,
  onGoToForm,
}: {
  businessEntity: IBusinessEntity;
  onGoToForm: () => void;
}) => {
  const { data: credentialsResponse } = useCredentials({
    businessEntityId: businessEntity.id,
    extends: [CredentialsGetExtensibleFields.SECRETS],
  });

  const irsCredential = credentialsResponse?.credentials?.find(
    (credential) =>
      credential.internalIdentifier ===
      RegistrationHelper.US_IRS_E_SERVICES_INTERNAL_IDENTIFIER
  );

  const { data: credentialResponse } = useCredential(irsCredential?.id, {
    includeSecret: true,
  });

  if (!credentialResponse || (credentialResponse && !irsCredential)) {
    return (
      <SummaryInfoWrapper title="Credentials" onGoToForm={onGoToForm}>
        <div className="flex flex-col gap-xl">
          <h1 className="text-sm">IRS Online Services</h1>
          <div className="rounded-xl overflow-clip divide-y divide-border-primary">
            <DataPoint
              title="User name"
              value="Not provided"
              description="User name"
            />
            <DataPoint
              title="Password"
              value="Not provided"
              description="Password"
            />
          </div>
        </div>
      </SummaryInfoWrapper>
    );
  }

  const blocks = credentialResponse?.credential?.blocks;
  const userName =
    blocks?.find((block) => block.type === CredentialBlockType.PlainText)
      ?.value || '';
  const password =
    blocks?.find((block) => block.type === CredentialBlockType.SecureString)
      ?.value || '';

  return (
    <SummaryInfoWrapper title="Credentials" onGoToForm={onGoToForm}>
      <div className="flex flex-col gap-3xl mt-3xl">
        <Alert
          title=""
          description="Ensure your credentials are accurate and up to date."
          variant="info"
          descriptionClassName="text-sm"
          icon={<Icons.InfoCircle className="size-4 text-utility-blue-500" />}
        />
        <div className="flex flex-col gap-xl">
          <h1 className="text-sm">IRS Online Services</h1>
          <div className="rounded-xl overflow-clip divide-y divide-border-primary">
            <DataPoint
              title="User name"
              value={userName || 'N/A'}
              description="User name"
            />
            <DataPoint
              title="Password"
              value={password || 'N/A'}
              description="Password"
            />
          </div>
        </div>
      </div>
    </SummaryInfoWrapper>
  );
};
